import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in by checking for JWT token
    const token = localStorage.getItem('jwtToken');
    
    if (token) {
      // User is logged in, redirect to home
      navigate('/home', { replace: true });
    } else {
      // User is not logged in, redirect to login
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  // Show a loading state while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        textAlign: 'center',
        color: '#6b7280'
      }}>
        <div style={{
          fontSize: '1.2rem',
          marginBottom: '10px'
        }}>
          Redirecting...
        </div>
        <div style={{
          fontSize: '0.9rem',
          opacity: 0.7
        }}>
          Please wait while we redirect you
        </div>
      </div>
    </div>
  );
};

export default RootRedirect;
